import React, { useEffect, useState } from "react";
import Header from "./header";
import Navbar from "./navbar";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getHomeData } from "../../../../feature-module/auth/services/apiCalling";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./footer";

const AboutDetailsMore: React.FC = () => {
  const [atMore, setAtMore] = useState(true)
  const location = useLocation();
  const base_Url = process.env.REACT_APP_BASE_URL;
  const allImagesLink = location?.state?.allImagesLink;
  const [hlanguage, setHlanguage] = useState<any>({});
  const [navbarLanguage, setNavbarLanguage] = useState(() => {
    // Get saved language from localStorage or default to "homeEn"
    return localStorage.getItem("selectedLanguage") || "homeEn";
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);


    // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
      const fetchAnnouncements = async (navLang) => {
        try {
          setLoading(true);
          const response = await getHomeData(navLang);
    
          if (response?.data?.success && response?.data?.data) {
            setHlanguage(response.data.data);
            setError(null);
          } else {
            const errorMsg = "Failed to load Data";
            setError(errorMsg);
            toast.error(errorMsg, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        } catch (err) {
          const errorMsg = "Failed to load Data";
          setError(errorMsg);
          toast.error(errorMsg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } finally {
          setLoading(false);
        }
      };
    useEffect(() => {
  
      fetchAnnouncements(navbarLanguage);
    }, [navbarLanguage]);

    // Save language to localStorage whenever it changes
    useEffect(() => {
      localStorage.setItem("selectedLanguage", navbarLanguage);
    }, [navbarLanguage]);

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <style>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          backdrop-filter: blur(5px);
        }

        .loader-spinner {
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top: 4px solid white;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .content-wrapper {
          transition: filter 0.3s ease;
        }

        .content-wrapper.blur {
          filter: blur(3px);
          pointer-events: none;
        }
      `}</style>

      {/* Loader Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="loader-spinner"></div>
        </div>
      )}

      {/* Content with blur effect when loading */}
      <div className={`content-wrapper ${loading ? "blur" : ""}`}>
        <Header hlanguage={hlanguage} allImagesLink={allImagesLink} />
        <Navbar setNavbarLanguage={setNavbarLanguage} hlanguage={hlanguage} atMore={atMore} />
        <div
                style={{
                backgroundImage: `url(${base_Url}${allImagesLink?.aboutUs?.find(
                      (item: any) => item?.fileName?.includes("about-more.png")
                    )?.fileUrl
                  })`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "120px",
                color: "white",
          }}
          className="d-flex align-items-center justify-content-start p-2"
          >
           {/* <h1 className="fw-bold text-white">
            <Link to="/" className="text-decoration-none text-white">
              Home
            </Link>{" "}
            &gt; About
          </h1> */}
          </div>
    <div className="w-100" style={{ background: "#FFF6D9" }}>
        
      <div className="container text-black py-4">

        {/* ================= INTRODUCTION ================= */}
        <h2 className="fw-bold fs-40">{hlanguage?.introduction}</h2>
        <p>
            {hlanguage?.aboutIntro1}
    </p>

    <p>
      {hlanguage?.aboutIntro2}
    </p>

    <p>
      {hlanguage?.aboutIntro3}
    </p>

    <p><strong>{hlanguage?.aboutIntro4}</strong></p>

    <p>
      {hlanguage?.aboutIntro5}
    </p>

    <ul>
      <li>{hlanguage?.aboutIntro6}</li>
      <li>{hlanguage?.aboutIntro7}</li>
      <li>
        {hlanguage?.aboutIntro8}
      </li>
      <li>
        {hlanguage?.aboutIntro9}
      </li>
      <li>{hlanguage?.aboutIntro10}</li>
    </ul>

    <p>
      {hlanguage?.aboutIntro11}
    </p>

    <hr />

    <h2 className="fs-40">{hlanguage?.missionAndVision}</h2>

    <p>
      {hlanguage?.missionAndVisionDesc}
    </p>

    <p>
      {hlanguage?.missVis1}
    </p>

    <p>
      {hlanguage?.missVis2}
    </p>

    <ul>
      <li>
        {hlanguage?.missVis3}
      </li>
      <li>
        {hlanguage?.missVis4}
      </li>
      <li>
        {hlanguage?.missVis5}
      </li>
    </ul>

    <p>
      {hlanguage?.missVis6}
    </p>

    <p>
      {hlanguage?.missVis7}
    </p>

    <ul>
      <li>{hlanguage?.missVis8}</li>
    </ul>

    <p>
      {hlanguage?.missVis9}
    </p>

      </div>
    </div>
    </div>
      {allImagesLink && <Footer allImagesLink={allImagesLink} hlanguage={hlanguage} />}       {/* Footer component */}
    </div>
  );
};

export default AboutDetailsMore;
